import React, { memo, useEffect, useState } from "react";
import { DatePicker } from "../Shared/DatePicker";
import { Button } from "../Shared/Button";
import { useAppDispatch } from "../../redux/store/hooks";
import { getExpertLessonRevenueHistory } from "../../redux/actions";
import useExpertRevenueManagementSelectors from "../../redux/selectors/expertRevenueManagement";
import { Typography } from "components/Shared/Typography";
import "./styles.scss";
import ExpertRevenueHistoryPreview from "./ExpertRevenueHistoryItem";
import { IRevenueHistoryItem } from "../../redux/reducers";
import { CardContent, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { triggerAlert } from "../../redux/reducers";
import { moneyPrefix, moneySuffix } from "../../utils/money";
import {
  translateFrontEndAlerts
} from "../../utils/translation";
import { Card } from "components/Shared/Card";
import { convertDateToIsoFormat } from "../../utils/dateFormat";
import NumericFormat from "react-number-format";

const initialValues = {
  startDate: null,
  endDate: null
};

const ExpertLessonHistory = () => {
  const [searchCriteria, setSearchCriteria] = useState<{
    startDate: null | Date;
    endDate: null | Date;
  }>(initialValues);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { lessonHistory, endDate, startDate, loading, totalPoints } =
    useExpertRevenueManagementSelectors();

  const handleChange = (name: string) => (value: Object) => {
    setSearchCriteria((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const generateRevenueHistoryPreview = (
    lessonHistory: IRevenueHistoryItem[]
  ) => {
    if (!lessonHistory || lessonHistory.length === 0) {
      return;
    }

    return (
      <ExpertRevenueHistoryPreview
        revenueItems={lessonHistory}
      />
    );
  };

  const _handleOnClick = () => {
    if (!searchCriteria.startDate || !searchCriteria.endDate) {
      dispatch(
        triggerAlert({
          type: "info",
          children: translateFrontEndAlerts(25001)
        })
      );
      return;
    }
    dispatch(
      getExpertLessonRevenueHistory({
        startDate: convertDateToIsoFormat(searchCriteria?.startDate),
        endDate: convertDateToIsoFormat(searchCriteria.endDate)
      })
    );
  };

  useEffect(() => {
    dispatch(getExpertLessonRevenueHistory({ startDate: null, endDate: null }));
  }, []);

  return (
    <div className="container">
      <div className="lesson-history">
        <div className="input-area">
          <Typography className="title">
            {t("expertRevenueManagement.lessonHistory.label.duration")}
          </Typography>
          <DatePicker
            local={i18n.language}
            disableKeyboardInputs={true}
            id="startDate"
            onChange={handleChange("startDate")}
            value={searchCriteria.startDate}
          />
          <span className="seperator">ー</span>
          <DatePicker
            local={i18n.language}
            disableKeyboardInputs={true}
            id="endDate"
            onChange={handleChange("endDate")}
            value={searchCriteria.endDate}
          />
          <Button
            id="ads"
            label={t("expertRevenueManagement.lessonHistory.label.searchBtn")}
            onClick={_handleOnClick}
          />
        </div>
        <Card>
          <CardContent className="card-content">
            <div className="total-row">
              <label>{t("purchasePoints.table.columnHeader.total")}</label>
              <div className="total-points">
                {
                  totalPoints
                  && <NumericFormat
                    value={totalPoints}
                    prefix={moneyPrefix(i18n.language)}
                    suffix={moneySuffix(i18n.language)}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    displayType="text"
                    renderText={(value) =>
                      <React.Fragment>{value}</React.Fragment>}
                  />
                }
              </div>
            </div>
            <div className="summary-area">
              {generateRevenueHistoryPreview(lessonHistory)}
            </div>
            {
              loading &&
              <div className="spinner_container">
                <CircularProgress color="success"
                                  className="spinner"
                                  size={20} />
              </div>
            }
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
export default memo(ExpertLessonHistory);
